<form #form="ngForm" class="app-grid">
    <ng-container *ngIf="workersCompensation">
        <div class="app-grid">
            <app-segment-header *ngIf="!isEditMode" [title]="title"> </app-segment-header>
            <ui-banner *ngIf="!isEditMode" variant="warning" class="margin-bottom-2">
                <p>{{ 'components.workers-compensation-rate.warning' | appTranslate }}</p>
            </ui-banner>
            <mat-form-field class="columns-12">
                <mat-label>{{ 'components.workers-compensation-rate.rateName' | appTranslate }}</mat-label>
                <input
                    matInput
                    type="text"
                    name="name"
                    required
                    #name="ngModel"
                    [(ngModel)]="workersCompensation.name"
                    placeholder="{{ 'components.workers-compensation-rate.rateNamePlaceholder' | appTranslate }}"
                />
            </mat-form-field>
            <mat-form-field [ngClass]="{ 'columns-4': !isEditMode, 'columns-6': isEditMode }">
                <mat-label appRemoveAriaOwns>{{
                    'components.workers-compensation-rate.year' | appTranslate
                }}</mat-label>
                <mat-select
                    placeholder="{{ 'components.workers-compensation-rate.yearPlaceholder' | appTranslate }}"
                    type="text"
                    required
                    name="year"
                    [(ngModel)]="workersCompensation.year"
                    [disabled]="isEditMode"
                >
                    <mat-option *ngFor="let year of years" [value]="year">{{ year }}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field [ngClass]="{ 'columns-4': !isEditMode, 'columns-6': isEditMode }">
                <mat-label appRemoveAriaOwns>{{
                    'components.workers-compensation-rate.jurisdiction' | appTranslate
                }}</mat-label>
                <mat-select
                    placeholder="{{ 'components.workers-compensation-rate.jurisdictionPlaceholder' | appTranslate }}"
                    type="text"
                    required
                    name="jurisdiction"
                    [(ngModel)]="workersCompensation.jurisdiction"
                    [disabled]="isEditMode"
                >
                    <mat-option *ngFor="let jurisdiction of jurisdictions" [value]="jurisdiction">{{
                        jurisdiction
                    }}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field [ngClass]="{ 'columns-4': !isEditMode, 'columns-6': isEditMode }">
                <mat-label>{{ 'components.workers-compensation-rate.rate' | appTranslate }}</mat-label>
                <input
                    matInput
                    type="number"
                    name="rate"
                    required
                    #name="ngModel"
                    [(ngModel)]="workersCompensation.rate"
                    placeholder="0.00"
                    [min]="0"
                    [max]="100"
                    step="0.01"
                    [disabled]="isEditMode"
                />
            </mat-form-field>
        </div>
    </ng-container>
</form>
